<mat-card class="mat-elevation-z0 data-container">
    <mat-card-title>Zoning Code: {{zoningCode?.Name}}</mat-card-title>
</mat-card>
<div style="display: flex;">
    <mat-card class="mat-elevation-z0 data-container statistic-card">
        <h2 class="section-header">General</h2>
        <div class="mat-typography content">
            <p>Gridics Id: {{zoningCode?.GridicsId}}</p>
            <p>Actual Version: {{zoningCode?.ActualVersion}}</p>
            <p>Effective Date: {{zoningCode?.effectiveDateFormatted||'-'}}</p>
            <p>Last Reviewed Date: {{zoningCode?.lastReviewedDateFormatted||'-'}}</p>
            <p style="display: flex;" title="{{zoningCode?.ZoningRegulationName}}">Zoning Regulation Name:&nbsp;
                <span class="wrapped-text">
                    {{zoningCode?.ZoningRegulationName||'-'}}</span>
            </p>
            <p style="display: flex;" title="{{zoningCode?.ZoningRegulationLink}}">Zoning Regulation Link:&nbsp;
                <a class="wrapped-text"
                    href="{{zoningCode?.ZoningRegulationLink}}">{{zoningCode?.ZoningRegulationLink||'-'}}</a>
            </p>
            <p style="display: flex;" title="{{zoningCode?.ZoningRegulationLink}}">Unit System:
                {{zoningCode?.unitSystemStr||'-'}}
            </p>
        </div>
    </mat-card>
    <mat-card class="mat-elevation-z0 data-container statistic-card">
        <h2 class="section-header">Property Records Statistic</h2>
        <app-zc-prs-statistic [metaData]="zoningCodeRecord?.MetaData"></app-zc-prs-statistic>
    </mat-card>
    <mat-card class="mat-elevation-z0 data-container statistic-card">
        <div style="display: flex;">
            <h2 class="section-header">Statistic By Zoning Code Statuses</h2>
            <app-update-zc-status-button style="padding-left: 10px;" [zoningCode]="zoningCode"
                [stateEnv]="stateEnv"></app-update-zc-status-button>
        </div>
        <div class="mat-typography" style="display: flex; margin-bottom: 3px;">
            <div style="width:135px">Zoning Code Status:</div>
            <div>{{getPrettyZCStatus(zoningCodeRecord?.Status)}}</div>
        </div>
        <div>
            <p class="section-subtitle mat-typography">Property Records : {{
                zoningCodeRecord?.MetaData?.cachedPRs?.total | number }}</p>
        </div>
        <div style="margin-top:3px;">
            <p class="section-subtitle mat-typography">Calculation Results</p>
            <app-zoning-code-statuses-list
                [statistic]="convertStatisticByStatusArray(zoningCodeRecord?.MetaData?.crCountByZCStatus)">
            </app-zoning-code-statuses-list>
        </div>
    </mat-card>
</div>

<mat-tab-group class="mat-elevation-z0" class="content-wrapper" #tabs mat-stretch-tabs="false">
    <mat-tab label="Statistic">
        <div class="chart-tool-bar">
            <app-update-zc-status-button style="padding: 2px 0 0 10px;" [zoningCode]="zoningCode"
                [stateEnv]="stateEnv"></app-update-zc-status-button>
        </div>
        <div style="display: flex;">
            <div style="min-width: 450px; max-width: 450px;">
                <mat-card class="mat-elevation-z0 data-container statistic-card">
                    <h2 class="section-header">Missed GAPI data Statistic</h2>
                    <app-prs-missed-entities-view
                        [zcMetaData]="zoningCodeRecord?.MetaData"></app-prs-missed-entities-view>
                </mat-card>
                <mat-card class="mat-elevation-z0 data-container statistic-card">
                    <h2 class="section-header">Performance Statistic</h2>
                    <app-zc-performance-details-view *ngIf="zoningCodeRecord?.MetaData?.performanceStatistic"
                        [zcStatistic]="zoningCodeRecord?.MetaData?.performanceStatistic">
                    </app-zc-performance-details-view>
                </mat-card>
                <mat-card class="mat-elevation-z0 data-container statistic-card">
                    <h2 class="section-header">Allowed Uses statistic</h2>
                    <app-zoning-code-versions-au-statistic
                        [zoningCodeRecord]="zoningCodeRecord"></app-zoning-code-versions-au-statistic>
                </mat-card>
            </div>
            <div style="min-width: 700px;">
                <app-zoning-code-pr-cr-statistic
                    [zoningCodeRecord]="zoningCodeRecord"></app-zoning-code-pr-cr-statistic>
            </div>
        </div>

    </mat-tab>

    <mat-tab label="Versions & Tasks">
        <mat-card class="mat-elevation-z0 list-container-width data-container">
            <h2 class="section-header">Versions</h2>
            <app-zoning-code-versions-list [zoningCode]="zoningCode" style="width: 100%;"
                class="zoning-code-versions-container" [showActions]="true" [showCheckStatusButton]="true"
                [showStatusColumn]="true" [showSetLastUpdateButton]="true" [stateEnv]="stateEnv">
            </app-zoning-code-versions-list>
        </mat-card>

        <mat-card class="mat-elevation-z0 list-container-width data-container">
            <h2 class="section-header">Tasks</h2>
            <app-tasks-list [tasks]="tasks" style="width: 100%;" class="zoning-code-versions-container"
                [showListBorders]="true" [showActions]="true" [showProcessDetailsPopupButton]="true"
                [showRecalculateButton]="false" [showClearThreadsButton]="false">
            </app-tasks-list>
        </mat-card>
    </mat-tab>

    <mat-tab label="Archived Tasks">
        <mat-card class="mat-elevation-z0 list-container-width data-container">
            <app-tasks-list [tasks]="archivedTasks" style="width: 100%;" class="zoning-code-versions-container"
                [showListBorders]="true" [showActions]="true" [showProcessDetailsPopupButton]="true"
                [showRecalculateButton]="false" [showClearThreadsButton]="false" [showStartStopButton]="false">
            </app-tasks-list>
        </mat-card>
    </mat-tab>

    <mat-tab label="Events">
        <mat-card class="mat-elevation-z0 data-container" style="padding: 0px !important;">
            <div class="chart-tool-bar" style="height: 42px;">
                <div style="width: 100%;">
                    <div class="mat-typography labeled-events-stat-container">
                        <span class="statistic-section-sub-header">Last Calculation:</span><app-events-stat-component
                            #calcEventsStatistic [statistic]="zoningCodeRecord?.MetaData?.lastCalculationStat"
                            [stateEnv]="stateEnv" [hideRefreshButton]="true"
                            style="width: 100%;"></app-events-stat-component>
                    </div>
                    <div class="mat-typography labeled-events-stat-container">
                        <span class="statistic-section-sub-header">Last Indexation:</span><app-events-stat-component
                            #indexEventsStatistic [statistic]="zoningCodeRecord?.MetaData?.lastIndexationStat"
                            [stateEnv]="stateEnv" [hideRefreshButton]="true"
                            style="width: 100%;"></app-events-stat-component>
                    </div>
                </div>
                <div style="padding-top: 7px;">
                    <app-update-system-events-list-button [stateEnv]="stateEnv" [parentId]="zoningCodeId"
                        [parentType]="systemEventParentType.ZONING_CODE"
                        [updateDataHandler]="updateEventsList.bind(this)"></app-update-system-events-list-button>
                </div>
            </div>
            <app-zoning-code-events-list [eventsList]="eventsList" [stateEnv]="stateEnv"></app-zoning-code-events-list>
        </mat-card>
    </mat-tab>

</mat-tab-group>
<app-spinner [showOverlay]="true" *ngIf="showSpinner"></app-spinner>